module.exports = __webpack_public_path__ + "static/camera9-087472f49e4a5fa5df768a1f333aa680.jpg";